import { jsx as o } from "react/jsx-runtime";
import r from "styled-components";
const t = r.span`
  position: absolute !important;
  width: 1px;
  height: 1px;
  overflow: hidden;
  padding: 0;
  margin: 0;
  clip: rect(1px 1px 1px 1px); /* IE 7+ only support clip without commas */
  clip: rect(1px, 1px, 1px, 1px); /* All other browsers */
  white-space: nowrap;
  border: 0;
`, a = ({ children: p, ...e }) => /* @__PURE__ */ o(
  t,
  {
    "aria-live": "assertive",
    ...e,
    children: p
  }
);
export {
  a as S
};
